import { Phone, FileText } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { PHONE_TEL } from "./data";

const StickyBar = () => (
  <div
    data-testid="mobile-sticky-bar"
    className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-slate-200 p-3 flex gap-3"
  >
    <a
      data-testid="sticky-call-button"
      href={PHONE_TEL}
      className="flex-1 inline-flex items-center justify-center gap-2 bg-slate-900 text-white font-bold py-3.5 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
    >
      <Phone className="w-4 h-4" /> Call
    </a>
    <button
      data-testid="sticky-quote-button"
      onClick={() => scrollToId("contact")}
      className="flex-1 inline-flex items-center justify-center gap-2 bg-amber-400 text-slate-950 font-bold py-3.5 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
    >
      <FileText className="w-4 h-4" /> Get a Quote
    </button>
  </div>
);

export default StickyBar;
